import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Outlet, useLocation } from 'react-router-dom';
import Header from './componentes/Header';
import Hero from './componentes/Hero';
import InfoCards from './componentes/InfoCards';
import PopularActions from './componentes/PopularActions';
import Services from './componentes/Services';
import Support from './componentes/Support';
import CTA from './componentes/CTA';
import Footer from './componentes/Footer';
import BuyingGuide from './pages/BuyingGuide';
import { TYPOGRAPHY } from './theme';
import Meta from './components/Meta';
import ServiceDetail from './pages/ServiceDetail';

const RootLayout = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <div className="app">
      <Header />
      <main>
        <div key={location.pathname} className="route-anim">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
};

const App = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    document.body.style.fontFamily = TYPOGRAPHY.body;
    
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  const Home = () => (
    <Meta title="C‑Store | Apple Tamir ve Destek" description="iPhone, iPad ve Mac için hızlı tamir, güvenilir destek ve uzman tavsiyeler. Randevu alın veya hemen iletişime geçin.">
      <>
        <Hero />
        <InfoCards />
        <PopularActions />
      </>
    </Meta>
  );

  const router = createBrowserRouter([
    {
      path: '/',
      element: <RootLayout />,
      children: [
        { index: true, element: <Home /> },
        { path: 'hizmetler', element: (
          <Meta title="Hizmetler | C‑Store" description="Ekran değişimi, batarya, anakart onarımı ve daha fazlası. Uzman teknisyenlerle kaliteli servis.">
            <Services />
          </Meta>
        ) },
        { path: 'hizmetler/:slug', element: (
          <Meta title="Hizmet Detayı | C‑Store" description="Ekran, batarya, su hasarı ve yazılım gibi hizmetlerin ayrıntıları.">
            <ServiceDetail />
          </Meta>
        ) },
        { path: 'destek', element: (
          <Meta title="Destek | C‑Store" description="Sık sorulan sorular, garanti bilgisi ve iletişim kanallarımız.">
            <Support />
          </Meta>
        ) },
        { path: 'iletisim', element: (
          <Meta title="İletişim | C‑Store" description="Telefon veya WhatsApp ile hemen bize ulaşın. Çalışma saatleri ve acil durum iletişim bilgileri.">
            <CTA />
          </Meta>
        ) },
        { path: 'rehber/:type', element: (
          <Meta title="Satın Alma Rehberi | C‑Store" description="iPhone, iPad ve daha fazlası için doğru seçimi yapmanıza yardımcı olacak ipuçları ve karşılaştırmalar.">
            <BuyingGuide />
          </Meta>
        ) }
      ]
    }
  ]);

  return <RouterProvider router={router} />;
};

export default App;